import React from 'react';
import { connect } from 'react-redux';

import { withTranslation } from 'providers/GILT.provider';

import SimpleDialog from 'scheduler/components/SimpleDialog';
import { deleteOrder, getOrderDetails, importBulkOrder, loadOrderList, scanOrder } from 'stocks/actions';
import HeaderStocksNavigation from 'stocks/components/HeaderStocksNavigation';
import Parent from 'stocks/components/OrderReceived/Parent';

class OrderReceived extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalLeaveStock: false,
      popUpId: 0,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.loadOrderList(this.props.salonId);
  }

  onOpenDetails = (orderId) => {
    this.setState({
      popUpId: orderId,
    });
  };

  render() {
    const { modalLeaveStock } = this.state;
    const {
      salonId,
      history,
      isFetching,
      orderList,
      currentOrderDetails,
      importBulkOrder,
      getOrderDetails,
      scanOrder,
      deleteOrder,
      t,
    } = this.props;

    const onRequestClose = () => {
      this.setState({
        modalLeaveStock: false,
      });
    };

    return (
      <div>
        <HeaderStocksNavigation salonId={salonId} history={history} />
        <div className="stock-order-layout">
          <div className="sticky-navbar-stock">
            <div className="order-date">{t('stocks.ordersReceived.tableHeaders.dateOrderGenerated')}</div>
            <div className="order-id">{t('stocks.ordersReceived.tableHeaders.orderId')}</div>
            <div className="items-number">{t('stocks.ordersReceived.tableHeaders.quantityOrdered')}</div>
            <div className="mark-as-scanned">{t('stocks.ordersReceived.tableHeaders.quantityImported')}</div>
            <div className=" bulk-link">{t('stocks.ordersReceived.tableHeaders.dateOrderImported')}</div>
            <div className="delete-order" />
          </div>
          {isFetching && (
            <div className="spinner-container">
              <div className="load-spinner" />
              <span className="spinner-text">{t('stocks.ordersReceived.loadingMsg')}</span>
            </div>
          )}
          {!isFetching && (
            <div>
              {orderList.map((order) => {
                const orderListItem = order;
                return (
                  <Parent
                    key={orderListItem.id}
                    popUpId={this.state.popUpId}
                    orderItem={orderListItem}
                    orderProductList={currentOrderDetails}
                    salonId={salonId}
                    importBulkOrder={importBulkOrder}
                    deleteOrder={deleteOrder}
                    getOrderDetails={getOrderDetails}
                    scanOrder={scanOrder}
                    onOpenDetails={this.onOpenDetails}
                  />
                );
              })}
            </div>
          )}
        </div>
        {modalLeaveStock && (
          <SimpleDialog
            title=" "
            leftButtonText={t('stocks.ordersReceived.backButton')}
            rightButtonText={t('stocks.ordersReceived.confirmButton')}
            onLeft={() => {}}
            onRight={onRequestClose}
            displayHeader="header-non"
            uniqueClass="wide-btn"
            isOpen={this.state.modalLeaveStock}
          >
            <div className="dialog-inner-title">{t('stocks.ordersReceived.leaveStocksDialog.title')}</div>
            <div className="dialog-text">
              <p>{t('stocks.ordersReceived.leaveStocksDialog.description')}</p>
            </div>
          </SimpleDialog>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId },
    stockManagement: {
      stockOrder: { isFetching, currentOrderDetails, orderList },
    },
  } = state;
  return {
    salonId,
    isFetching,
    currentOrderDetails,
    orderList,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    loadOrderList(salonId) {
      dispatch(loadOrderList(salonId));
    },
    importBulkOrder(salonId, orderId, orderList) {
      dispatch(importBulkOrder(salonId, orderId, orderList));
    },
    deleteOrder(salonId, orderId) {
      dispatch(deleteOrder(salonId, orderId));
    },
    getOrderDetails(salonId, orderId) {
      dispatch(getOrderDetails(salonId, orderId));
    },
    scanOrder(salonId, orderId) {
      dispatch(scanOrder(salonId, orderId));
    },
  };
}

const OrderReceivedHoc = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OrderReceived));
export default OrderReceivedHoc;
